import {sweetAPI} from 'app/store/sweet-api';
import {showLoadingBar, showMessages} from 'app/store/sweet-api/utils';
import {SEARCH_API_COUNT_URL, SEARCH_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {SearchFetchParamsType} from './types';
import type {ListResponseType, SearchSerializedType} from 'sweet-types';

export const SEARCH_TAG = 'search';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [SEARCH_TAG]})
  .injectEndpoints({
    endpoints: (build) => ({
      getSearchResults: build.query<
        ListResponseType<SearchSerializedType>,
        Partial<SearchFetchParamsType>
      >({
        query: (params) => ({
          url: SEARCH_API_URL,
          params: params ?? {},
        }),
        providesTags: () => [{type: SEARCH_TAG, id: 'list'}],
        onQueryStarted: (args, api) => {
          showMessages({
            onError: () => gt('Unable to perform search'),
          })(args, api);
          showLoadingBar(args, api);
        },
      }),

      getSearchCounts: build.query<{count: number}, SearchFetchParamsType>({
        query: (params) => ({url: SEARCH_API_COUNT_URL, params}),
      }),
    }),
  });

export const {
  useQuery: useSearchResults,
  useQueryState: useSearchResultsState,
} = extendedAPI.endpoints.getSearchResults;

export const {useQuery: useSearchCounts, useQueryState: useSearchCountsState} =
  extendedAPI.endpoints.getSearchCounts;
